"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[688],{

/***/ 61256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71383);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33546);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39234);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46133);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



var _excluded = ["children", "className", "onPrimaryBg"],
    _excluded2 = ["node", "children", "href"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var StyledA = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  color: ", ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
      $onPrimaryBg = _ref.$onPrimaryBg;
  return $onPrimaryBg ? theme.colors.linkColours.main : theme.colors.primary;
}, function (_ref2) {
  var theme = _ref2.theme,
      $onPrimaryBg = _ref2.$onPrimaryBg;
  return $onPrimaryBg ? theme.colors.linkColours.mainHover : theme.colors.text;
});
var StyledReactMarkdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_markdown__WEBPACK_IMPORTED_MODULE_6__/* .ReactMarkdown */ .D)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  line-height: 1.6;\n  font-size: 1.6rem;\n  @media screen and (max-width: ", ") {\n    font-size: 1.5rem;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.maxWidth;
});

var MarkdownText = function MarkdownText(_ref4) {
  var children = _ref4.children,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      onPrimaryBg = _ref4.onPrimaryBg,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref4, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledReactMarkdown, _objectSpread(_objectSpread({}, props), {}, {
    className: "markdown-text-wrapper ".concat(className),
    rehypePlugins: [rehype_raw__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z],
    components: {
      a: function a(_ref5) {
        var node = _ref5.node,
            children = _ref5.children,
            href = _ref5.href,
            aProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref5, _excluded2);

        var isExternal = href.startsWith('http');
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: href,
          passHref: true,
          legacyBehavior: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledA, _objectSpread(_objectSpread({}, aProps), {}, {
            target: isExternal ? '_blank' : undefined,
            rel: isExternal ? 'noopener' : undefined,
            $onPrimaryBg: onPrimaryBg,
            children: children
          }))
        });
      }
    },
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (MarkdownText);

/***/ }),

/***/ 13688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DynamicZone; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(46133);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/dynamic-zone/image.js


var _templateObject, _templateObject2, _templateObject3;





var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 4rem 0;\n"])));
var Image = (0,styled_components_browser_esm/* default */.ZP)((image_default()))(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    border-radius: 5px;\n"])));
var Caption = styled_components_browser_esm/* default.span */.ZP.span(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: block;\n    margin: 1rem 0;\n"])));
function ImageBlock(_ref) {
  var _block$image, _block$image$data, _block$image$data$att, _block$image2, _block$image2$data, _block$image2$data$at, _block$image3, _block$image3$data, _block$image3$data$at, _block$image4, _block$image4$data, _block$image4$data$at, _block$image5, _block$image5$data, _block$image5$data$at;

  var block = _ref.block;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ImageWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      src: (_block$image = block.image) === null || _block$image === void 0 ? void 0 : (_block$image$data = _block$image.data) === null || _block$image$data === void 0 ? void 0 : (_block$image$data$att = _block$image$data.attributes) === null || _block$image$data$att === void 0 ? void 0 : _block$image$data$att.url,
      width: (_block$image2 = block.image) === null || _block$image2 === void 0 ? void 0 : (_block$image2$data = _block$image2.data) === null || _block$image2$data === void 0 ? void 0 : (_block$image2$data$at = _block$image2$data.attributes) === null || _block$image2$data$at === void 0 ? void 0 : _block$image2$data$at.width,
      height: (_block$image3 = block.image) === null || _block$image3 === void 0 ? void 0 : (_block$image3$data = _block$image3.data) === null || _block$image3$data === void 0 ? void 0 : (_block$image3$data$at = _block$image3$data.attributes) === null || _block$image3$data$at === void 0 ? void 0 : _block$image3$data$at.height,
      layout: "responsive",
      alt: (_block$image4 = block.image) === null || _block$image4 === void 0 ? void 0 : (_block$image4$data = _block$image4.data) === null || _block$image4$data === void 0 ? void 0 : (_block$image4$data$at = _block$image4$data.attributes) === null || _block$image4$data$at === void 0 ? void 0 : _block$image4$data$at.alternativeText,
      style: {
        borderRadius: '5px'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Caption, {
      children: (_block$image5 = block.image) === null || _block$image5 === void 0 ? void 0 : (_block$image5$data = _block$image5.data) === null || _block$image5$data === void 0 ? void 0 : (_block$image5$data$at = _block$image5$data.attributes) === null || _block$image5$data$at === void 0 ? void 0 : _block$image5$data$at.caption
    })]
  });
}
// EXTERNAL MODULE: ./components/atoms/markdown.js
var markdown = __webpack_require__(61256);
;// CONCATENATED MODULE: ./components/dynamic-zone/index.js





function Block(_ref) {
  var block = _ref.block;

  switch (block.__component) {
    case "content-blocks.rich-text":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(markdown["default"], {
        prose: true,
        children: block.text
      });

    case "content-blocks.image":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageBlock, {
        block: block
      });
  }

  return null;
}

function DynamicZone(_ref2) {
  var blocks = _ref2.blocks;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: blocks.map(function (block, idx) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Block, {
        block: block
      }, idx);
    })
  });
}

/***/ })

}]);